﻿'use strict';

angular.module('ntmApp')
  .directive('breadcrumbs', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/dailyPlan/directives/templates/breadcrumbs.html',
          scope: {
              items: '=',
              selected: '=',
              display: '@',
              additionalDisplay: '@',
              key: '@',
              value: '@',
              select: '&',
              level: '@',
              hasChild: '='
          },
          link: function () {}
      };
  });